import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Plot from "react-plotly.js";
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
}

export default function Relay(props: Props) {
    const [relay1, setRelay1] = useState('UNKNOWN');
    const [relay2, setRelay2] = useState('UNKNOWN');
    const [relay3, setRelay3] = useState('UNKNOWN');
    const [relay4, setRelay4] = useState('UNKNOWN');
    const [relay1name, setRelay1Name] = useState('---');
    const [relay2name, setRelay2Name] = useState('---');
    const [relay3name, setRelay3Name] = useState('---');
    const [relay4name, setRelay4Name] = useState('---');
    
    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            if(SNStatus[props.index].Relay.Relays.length <= 0) {
                setRelay1('UNKNOWN');
                setRelay2('UNKNOWN');
                setRelay3('UNKNOWN');
                setRelay4('UNKNOWN');
                setRelay1Name('---');
                setRelay2Name('---');
                setRelay3Name('---');
                setRelay4Name('---');
            } else {
                if(SNStatus[props.index].Relay.Relays.length > 0) {
                    setRelay1(SNStatus[props.index].Relay.Relays[0].Status);
                    if(SNStatus[props.index].Relay.Relays[0].Name.length > 0) {
                        setRelay1Name(SNStatus[props.index].Relay.Relays[0].Name);
                    } else {
                        setRelay1Name('---');
                    }
                }
                if(SNStatus[props.index].Relay.Relays.length > 1) {
                    setRelay2(SNStatus[props.index].Relay.Relays[1].Status);
                    if(SNStatus[props.index].Relay.Relays[1].Name.length > 0) {
                        setRelay2Name(SNStatus[props.index].Relay.Relays[1].Name);
                    } else {
                        setRelay2Name('---');
                    }
                }
                if(SNStatus[props.index].Relay.Relays.length > 2) {
                    setRelay3(SNStatus[props.index].Relay.Relays[2].Status);
                    if(SNStatus[props.index].Relay.Relays[2].Name.length > 0) {
                        setRelay3Name(SNStatus[props.index].Relay.Relays[2].Name);
                    } else {
                        setRelay3Name('---');
                    }
                }
                if(SNStatus[props.index].Relay.Relays.length > 3) {
                    setRelay4(SNStatus[props.index].Relay.Relays[3].Status);
                    if(SNStatus[props.index].Relay.Relays[3].Name.length > 0) {
                        setRelay4Name(SNStatus[props.index].Relay.Relays[3].Name);
                    } else {
                        setRelay4Name('---');
                    }
                }
            }
        } else {
            setRelay1('UNKNOWN');
            setRelay2('UNKNOWN');
            setRelay3('UNKNOWN');
            setRelay4('UNKNOWN');
            setRelay1Name('---');
            setRelay2Name('---');
            setRelay3Name('---');
            setRelay4Name('---');
        } 
    }, [SNTime, props.index]);
    
    return (
        <div>
            <Table><TableBody>
                <TableRow style={{border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                    <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '95%', backgroundColor: 'black'}} padding='none'>
                        { (relay1 === "UNKNOWN") && <button className="bnt_grey">{relay1name}</button> }
                        { (relay1 === "ON") && <button className="bnt_green">{relay1name}</button> }
                        { (relay1 === "OFF") && <button className="bnt_red_flash">{relay1name}</button> }
                    </TableCell>
                </TableRow>       
                <TableRow style={{border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>             
                    <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '95%', backgroundColor: 'black'}} padding='none'>
                        { (relay2 === "UNKNOWN") && <button className="bnt_grey">{relay2name}</button> }
                        { (relay2 === "ON") && <button className="bnt_green">{relay2name}</button> }
                        { (relay2 === "OFF") && <button className="bnt_red_flash">{relay2name}</button> }
                    </TableCell>
                </TableRow> 
                <TableRow style={{border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>                   
                    <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '95%', backgroundColor: 'black'}} padding='none'>
                        { (relay3 === "UNKNOWN") && <button className="bnt_grey">{relay3name}</button> }
                        { (relay3 === "ON") && <button className="bnt_green">{relay3name}</button> }
                        { (relay3 === "OFF") && <button className="bnt_red_flash">{relay3name}</button> }
                    </TableCell>
                </TableRow>
                <TableRow style={{border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                    <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '95%', backgroundColor: 'black'}} padding='none'>
                        { (relay4 === "UNKNOWN") && <button className="bnt_grey">{relay4name}</button> }
                        { (relay4 === "ON") && <button className="bnt_green">{relay4name}</button> }
                        { (relay4 === "OFF") && <button className="bnt_red_flash">{relay4name}</button> }
                    </TableCell>
                </TableRow>
            </TableBody></Table>
        </div>
    )
}
